var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroller',{ref:"scroller",attrs:{"on-infinite":_vm.infinite,"on-refresh":_vm.refresh}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }